import { createContext, useContext } from 'react';
export const AssociatedObjectsCardRedesignContext = /*#__PURE__*/createContext({
  cardId: '',
  fromObjectId: 0,
  fromObjectTypeId: '',
  hasScope: () => false,
  isUngated: () => false,
  isLoading: true,
  objectPermissions: {
    currentUserCanCreate: false,
    currentUserCanEdit: false,
    currentUserCanEditAssociations: false,
    hasHitAssociationLimit: false
  },
  onPreview: () => {},
  onRefetchLegacySidebar: () => {},
  onObjectCreate: () => {},
  onSearchQueryChange: () => {},
  onSortConfigurationChange: () => {},
  propertyNames: [],
  readOnly: false,
  refetchObjectData: () => {},
  toObjectTypeId: '',
  userPermissions: {
    currentUserCanEdit: false,
    currentUserCanEditAssociations: false
  },
  userPermission: false
});
export function useAssociatedObjectsCardRedesignContext() {
  const context = useContext(AssociatedObjectsCardRedesignContext);
  return context;
}